import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import About from './components/About';
import CuisineMenu from './components/CuisineMenu';
import Services from './components/Services';
import Banner from './components/Banner';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Floats from './components/Floats';

function App() {
  return (
    <div style={{ background: '#0a0a0a' }}>
      <Navbar />
      <Hero />
      <Stats />
      <About />
      <CuisineMenu />
      <Services />
      <Banner />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
      <Floats />
    </div>
  );
}

export default App;